module.exports = __webpack_public_path__ + "static/media/alchemy-machine-1.d6f3ad7a.glb";